import { render, staticRenderFns } from "./HotmartApp.vue?vue&type=template&id=3c39be3e&scoped=true"
import script from "./HotmartApp.vue?vue&type=script&lang=js"
export * from "./HotmartApp.vue?vue&type=script&lang=js"
import style0 from "./HotmartApp.vue?vue&type=style&index=0&id=3c39be3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39be3e",
  null
  
)

export default component.exports